import { useSelector } from "react-redux";
import {
  getDevelopmentSelectModels,
  selectDevelopmentSelectModels,
  selectLastUpdateTime,
  selectLoading,
  selectServiceChargeDevelopmentModels,
  selectServiceChargeLastUpdatedTime,
} from "./components/DevelopmentSelectSlice";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import MultiSelectDropdown from "cpl-react-common/components/Inputs/MultiSelectDropdown";
import useCaching, { CachingOptions } from "cpl-react-common/Hooks/useCaching";
import { useThunkDispatch } from "setup/redux/thunkDispatch";

type DevelopmentSelectProps = {
  "data-test-id"?: string;
  handleChange: (selections: string[]) => void;
  defaultAll: boolean;
  defaultSome?: string[];
  isServiceChargeOnly?: boolean;
};

const EXPIRY_PERIOD_MS = 1000 * 60 * 60; // 1 hour

const DevelopmentSelectMulti: React.FC<DevelopmentSelectProps> = (props) => {
  const thunkDispatch = useThunkDispatch();
  const loading = useSelector(selectLoading);
  const developmentSelectModels = useSelector(
    props.isServiceChargeOnly ? selectServiceChargeDevelopmentModels : selectDevelopmentSelectModels
  );
  const lastUpdateTime = useSelector(
    props.isServiceChargeOnly ? selectServiceChargeLastUpdatedTime : selectLastUpdateTime
  );

  const updateSelectModels = () => {
    thunkDispatch(getDevelopmentSelectModels(props.isServiceChargeOnly));
  };
  const cachingOptions: CachingOptions = {
    lastUpdateTime,
    expiryPeriodMs: EXPIRY_PERIOD_MS,
    updateData: updateSelectModels,
    shouldUpdateOnLoad: developmentSelectModels.length === 0,
  };

  useCaching(cachingOptions);

  return (
    <ActivityIndicator isBusy={loading}>
      <MultiSelectDropdown
        data-test-id={props["data-test-id"]}
        handleChange={(selections) => props.handleChange(selections as string[])}
        options={developmentSelectModels.map((x) => ({
          value: x.value!,
          label: x.label ?? "",
        }))}
        defaultAll={props.defaultAll}
        defaultSome={props.defaultSome}
        searchable={true}
      ></MultiSelectDropdown>
    </ActivityIndicator>
  );
};

export default DevelopmentSelectMulti;
